module.exports = __webpack_public_path__ + "static/john_mcmanus-7e40282fe04a92f8c36185d81fcf4803.jpg";